import React from 'react'
import { EqDates, EquifaxAddress } from '../../equifax-credit-report'
import { yyyymmdd, extractDate } from '../../date-utils'

type AddressesProps = {
  addresses: EquifaxAddress[]
}

export const Addresses = ({ addresses }: AddressesProps) => {
  if (!addresses || addresses.length === 0) {
    return (
      <div>
        <h4>Addresses (0)</h4>
        <p className="text-muted">No addresses found</p>
      </div>
    )
  }

  return (
    <div>
      <h5>Addresses ({addresses.length})</h5>

      <div className="table-responsive">
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              <th>Address</th>
              <th>Type</th>
              <th>First Reported</th>
              <th>Last Reported</th>
            </tr>
          </thead>
          <tbody>
            {addresses.map((address, index) => (
              <tr key={index}>
                <td>
                  {[address.addressLine1, address.addressLine2].filter(Boolean).join(' ')}&nbsp;
                  {address.cityName}, {address.stateAbbreviation} {address.zipCode}
                </td>
                <td className="text-secondary">
                  {address.addressType || 'N/A'}
                </td>
                <td>
                  {address.dateFirstReported
                    ? yyyymmdd(EqDates.toDate(address.dateFirstReported))
                    : 'N/A'
                  }
                </td>
                <td>
                  {address.dateLastReported
                    ? yyyymmdd(EqDates.toDate(address.dateLastReported))
                    : 'N/A'
                  }
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default Addresses